(function () {
  var isTouchOnly = window.matchMedia('(hover: none)').matches;

  function copyToClipboard(text, button, feedback) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        var label = button.querySelector('.product-share__label');
        var orig = label ? label.textContent : button.getAttribute('aria-label') || '';
        if (label) label.textContent = feedback;
        button.setAttribute('aria-label', feedback);
        setTimeout(function () {
          if (label) label.textContent = orig;
          button.setAttribute('aria-label', orig);
        }, 2000);
      });
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      try {
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        var label = button.querySelector('.product-share__label');
        var orig = label ? label.textContent : button.getAttribute('aria-label') || '';
        if (label) label.textContent = feedback;
        button.setAttribute('aria-label', feedback);
        setTimeout(function () {
          if (label) label.textContent = orig;
          button.setAttribute('aria-label', orig);
        }, 2000);
      } finally {
        if (ta.parentNode) ta.parentNode.removeChild(ta);
      }
    }
  }

  function init(btn) {
    var url = btn.dataset.shareUrl;
    var title = btn.dataset.shareTitle;
    var copiedText = btn.dataset.shareCopied;
    if (!url) return;
    if (isTouchOnly) {
      var block = btn.closest('.product-share-block');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        block.classList.toggle('product-share-block--actions-open');
      });
      return;
    }
    btn.addEventListener('click', function () {
      if (typeof navigator.share === 'function') {
        navigator.share({ url: url, title: title }).catch(function () {
          copyToClipboard(url, btn, copiedText);
        });
      } else {
        copyToClipboard(url, btn, copiedText);
      }
    });
  }

  function initMobileClose() {
    if (!isTouchOnly) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('.product-share-block')) return;
      document.querySelectorAll('.product-share-block--actions-open').forEach(function (block) {
        block.classList.remove('product-share-block--actions-open');
      });
    });
  }

  function initCopy(btn) {
    var url = btn.dataset.shareUrl;
    var copiedText = btn.dataset.shareCopied;
    if (!url) return;
    btn.addEventListener('click', function () {
      copyToClipboard(url, btn, copiedText);
    });
  }

  document.querySelectorAll('.product-share-block .product-share__button').forEach(init);
  document.querySelectorAll('.product-share-block .product-share__copy').forEach(initCopy);
  initMobileClose();
})();
